import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, Drawer, Text} from '@optimaxdev/design-system';
import {Exit, Icon} from '@optimaxdev/icons';
import {useDispatch, useSelector} from 'react-redux';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';

import {TYP_CONTACT_LENSES} from 'constants/analytics/events/typ';
import {CL_RX_METHOD} from 'constants/success';
import {getButtonLabel} from 'libs/success/helpers/helpers';
import {getPopupType} from 'libs/success/prescriptionPopup/prescriptionPopup';

import {getDrawerState} from '../../../selectorsV2';

import {setDrawerState} from '../../../store/reducers/drawerPopup/drawerPopup';

import {DefaultDrawerScreen} from '../defaultDrawerScreen/defaultDrawerScreen';

import {METHODS} from './helpers';

import s from './drawerContainer.scss';

/**
 * The container for the drawer
 */
export const DrawerContainer = () => {
    const {isOpen, item, rxMethod, title} = useSelector(getDrawerState);
    const dispatch = useDispatch();
    const isEyeExam =
        rxMethod === CL_RX_METHOD.EYE_EXAM ||
        rxMethod === CL_RX_METHOD.EYE_EXAM_ELIGIBILITY ||
        rxMethod === CL_RX_METHOD.EYE_EXAM_ELIGIBILITY_FAILED;
    const type = getPopupType(item, '');
    const closeDrawer = () => {
        const label = getButtonLabel(type);

        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${isEyeExam ? 'Online Exam' : label} - Close`,
        );

        dispatch(setDrawerState(false));
    };

    const product = item?.product;

    return (
        <>
            <Drawer
                customHeader={
                    <div className={s.container}>
                        <div className={s.leftSide}>
                            <CloudinaryImage
                                alt={product?.name}
                                height={36}
                                src={product?.image || ''}
                                width={59}
                            />
                            <div className={s.verticalLine} />
                            <Text color={Colors.codGray} lineHeight="22px" size="16px" bold>
                                {title}
                            </Text>
                        </div>
                        <button className={s.exit} onClick={closeDrawer} type="button">
                            <Icon
                                color={Colors.limedSpruce}
                                height={12}
                                icon={Exit}
                                strokeWidth={1.5}
                                width={12}
                            />
                        </button>
                    </div>
                }
                isOpened={isOpen}
                onClick={closeDrawer}
            >
                <div className={s.content}>{METHODS[rxMethod] || <DefaultDrawerScreen />}</div>
            </Drawer>
        </>
    );
};
